import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20match%20photography%20with%20players%20in%20intense%20action%20on%20the%20pitch%20under%20bright%20stadium%20lights%2C%20dramatic%20sports%20moment%2C%20editorial%20style%2C%20clean%20composition&width=800&height=450&seq=article-football-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20with%20players%20driving%20to%20the%20hoop%20in%20a%20packed%20arena%2C%20intense%20competitive%20atmosphere%2C%20dynamic%20motion%2C%20professional%20sports%20photography&width=800&height=450&seq=article-basketball-1&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Tennis%20player%20serving%20powerfully%20on%20a%20grass%20court%20at%20Wimbledon%2C%20dramatic%20lighting%2C%20white%20outfit%2C%20classic%20tennis%20aesthetic%2C%20professional%20sports%20photography&width=800&height=450&seq=article-tennis-1&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Esports%20tournament%20stage%20with%20professional%20teams%20competing%20on%20computers%20under%20colorful%20LED%20lights%2C%20modern%20gaming%20arena%2C%20enthusiastic%20crowd%2C%20vibrant%20atmosphere&width=800&height=450&seq=article-esports-1&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Table%20tennis%20player%20in%20intense%20rally%20at%20world%20championship%2C%20fast%20motion%20blur%20on%20the%20ball%2C%20focused%20athlete%2C%20professional%20indoor%20sports%20photography%2C%20clean%20background&width=800&height=450&seq=article-comprehensive-1&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Premier%20League%20soccer%20stadium%20with%20floodlights%20at%20night%2C%20players%20celebrating%20a%20goal%2C%20dramatic%20atmosphere%2C%20passionate%20fans%20in%20the%20background%2C%20cinematic%20sports%20photography&width=800&height=450&seq=article-football-2&orientation=landscape',
};

export default function ArticleList() {
  const { t } = useTranslation();

  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            {t('home.articles.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('home.articles.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 transition-all duration-300 hover:scale-[1.01] cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-xs font-medium bg-primary-500 text-background-50 px-2.5 py-1 rounded">
                  {article.category === 'football' ? '足球' : article.category === 'basketball' ? '篮球' : article.category === 'tennis' ? '网球' : article.category === 'esports' ? '电竞' : '综合体育'}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 font-heading group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishedAt}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount >= 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/category/football"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}